module.exports = __webpack_public_path__ + "img/background027.75982bbb.jpg";